import { api } from "../../api/http";

const BASE = "/api/backoffice/users/";

export async function listUsers(params = {}) {
	const res = await api.get(BASE, { params });
	return res.data;
}

export async function createUser(payload) {
	const res = await api.post(BASE, payload);
	return res.data;
}

export async function updateUser(id, payload) {
	const res = await api.patch(`${BASE}${id}/`, payload);
	return res.data;
}

export async function deleteUser(id) {
	const res = await api.delete(`${BASE}${id}/`);
	return res.data;
}

export async function generateUserPassword(id) {
	const res = await api.post(`${BASE}${id}/generate-password/`);
	return res.data;
}

export async function getStudentProfile(id) {
	const res = await api.get(`${BASE}${id}/student-profile/`);
	return res.data;
}
